import ApplicationApi from 'api/digifi/application/ApplicationApi';
import OfferCodeApi from 'api/digifi/application/OfferCodeApi';
import PreFillApi from 'api/digifi/application/PreFillApi';
import SocureApi from 'api/SocureApi';
import StatusApi from 'api/StatusApi';
import TwilioApi from 'api/TwilionApi';
import { submitApplication } from './application';
import { createGetApplicationStepThunk } from './createGetApplicationStepThunk';
import { createGetPreFillExperianDataThunk } from './createGetPreFillExperianDataThunk';
import { createOfferPrepopulatedDataThunk } from './createOfferPrepopulatedDataThunk';
import { createFetchDeploymentStatusThunk } from './createStatusThunk';
import { createVerifyCodeThunk } from './createVerifyCodeThunk';
import { getDocumentVerificationResultThunk } from './getDocumentVerificationResult';
import { createGetOfferCodeDataThunk } from './getOfferCodeData';
import { resendPhoneVerificationThunk } from './resendPhoneVerification';
import { createValidateOfferCodeThunk } from './validateOfferCode';

const applicationApi = new ApplicationApi();
const twilioApi = new TwilioApi();
const statusApi = new StatusApi();
const socureApi = new SocureApi();
const offerCodeApi = new OfferCodeApi();
const preFillApi = new PreFillApi();

export const submitApplicationData = submitApplication(applicationApi);
export const validateOfferCodeData = createValidateOfferCodeThunk(offerCodeApi);
export const fetchOfferPrepopulatedData = createOfferPrepopulatedDataThunk(offerCodeApi);
export const getOfferCodeData = createGetOfferCodeDataThunk(offerCodeApi);
export const fetchPreFillExperianData = createGetPreFillExperianDataThunk(preFillApi);

export const resendPhoneVerification = resendPhoneVerificationThunk(twilioApi);
export const verifyCode = createVerifyCodeThunk(twilioApi);
export const getDeploymentStatus = createFetchDeploymentStatusThunk(statusApi);
export const getApplicationStepThunk = createGetApplicationStepThunk(applicationApi);
export const getDocumentVerificationResult = getDocumentVerificationResultThunk(socureApi);
